export const bucketEngagementScore = (score: number | undefined) => {
  if (!score) {
    return 'Unknown'
  }
  const roundedScore = Math.round(score)
  if (roundedScore < 2) {
    return 'Not engaged'
  } else if (roundedScore < 3) {
    return 'Somewhat engaged'
  } else if (roundedScore < 4) {
    return 'Engaged'
  } else if (roundedScore < 5) {
    return 'Very engaged'
  } else {
    return 'Extremely engaged'
  }
}
